import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuthStore } from '@/stores';
import { SignInFlowView, ManageMyProfile } from '@/views';
import {
	RequestPasscode,
	SubmitPasscode,
	UserPass,
	UserPassTwoScreen,
	ResetPassword,
	AspireInterstitial,
	ResetPasswordByPasscodeSpecifyLogin
} from '@/components/SignInFlow';
import RequestSendUserNames from '@/components/SignInFlow/RequestSendUserNames.vue';
import RequestSendUserNamesAfter from '@/components/SignInFlow/RequestSendUserNamesAfter.vue';

const { VITE_TWO_STEP_SIGNIN_SYSROOTS } = import.meta.env;

const twoStepSysRoots = VITE_TWO_STEP_SIGNIN_SYSROOTS
	? VITE_TWO_STEP_SIGNIN_SYSROOTS.split('|')
	: [];

const twoStepLoginFlow = twoStepSysRoots
	.map((sysroot) => location.pathname.startsWith(sysroot))
	.some((t) => t);

export const failoverRoute = {
	path: '/:pathMatch(.*)*',
	name: 'failover',
	redirect: '/'
};

export const router = createRouter({
	history: createWebHashHistory(),
	linkActiveClass: 'active',
	routes: [
		{
			path: '/profile',
			name: 'profile',
			component: ManageMyProfile
		},
		{
			path: '/',
			name: 'signin',
			component: SignInFlowView,
			children: [
				{
					path: 'requestpasscode',
					name: 'requestpasscode',
					component: RequestPasscode,
					meta: { headline: 'Please sign in.' }
				},
				{
					path: 'sendpasscode',
					name: 'sendpasscode',
					component: SubmitPasscode,
					meta: { headline: 'Please sign in.' }
				},
				{
					path: 'resetpasswordbypasscode/specifylogin',
					name: 'resetpasswordbypasscodespecifylogin',
					component: ResetPasswordByPasscodeSpecifyLogin,
					meta: { headline: "Let's reset your password." }
				},
				{
					path: 'resetpasswordbypasscode',
					name: 'resetpasswordbypasscode',
					component: ResetPassword,
					props: {
						withPasscode: true,
						helpText:
							'A one-time passcode has been sent by email and/or text message.' +
							' Please enter your passcode and set your new password'
					},
					meta: { headline: "Let's reset your password." }
				},
				{
					path: 'recoverUserName/done',
					name: 'recoverusernameafter',
					component: RequestSendUserNamesAfter,
					meta: { headline: 'Your username is on the way.' }
				},
				{
					path: 'recoverUserName',
					name: 'recoverusername',
					component: RequestSendUserNames,
					meta: { headline: 'Recover your username.' }
				},
				{
					path: 'resetpassword',
					name: 'resetpassword',
					component: ResetPassword,
					meta: { headline: "Let's reset your password." },
					props: {
						withPasscode: false,
						headlineText:
							'A password reset is required. Please reset your password below.'
					}
				},
				{
					path: 'loading',
					name: 'loading',
					component: AspireInterstitial,
					meta: { headline: "Let's take you to the system..." }
				},
				{
					path: '',
					name: 'signinuserpass',
					component: twoStepLoginFlow ? UserPassTwoScreen : UserPass,
					meta: { headline: 'Please sign in.' }
				}
			]
		}
	]
});

export const appRoutes = [];

router.beforeEach(async (to, from) => {
	// redirect to signin page if not logged in and trying to access a restricted page
	const { VITE_SIGNIN_BASEURL } = import.meta.env;
	const publicPages = [
		VITE_SIGNIN_BASEURL,
		`${VITE_SIGNIN_BASEURL}resetpasswordbypasscode`,
		`${VITE_SIGNIN_BASEURL}resetpasswordbypasscode/specifylogin`,
		`${VITE_SIGNIN_BASEURL}recoverUserName`,
		`${VITE_SIGNIN_BASEURL}recoverUserName/done`
	];
	const authStore = useAuthStore();
	const authRequired =
		(!authStore.authToken && !publicPages.includes(to.path)) ||
		(to.path === '/requestpasscode' &&
			authStore.signInState !== 'mfaRequesting') ||
		(to.path === '/sendpasscode' &&
			authStore.signInState !== 'mfaSubmitting');

	if (authRequired) {
		return {
			path: VITE_SIGNIN_BASEURL,
			query: {}
		};
	}
});
